
export const PieChartStyles = {
  '& .PieChart__wrapper': {
    position: "relative",
  },
  '& .toggle-table-btn': {
    fontWeight: "bold",
    left: "10px",
    position: "absolute",
    bottom: "10px",
    zIndex: "1",
  },
  '& .highcharts-pie-series > span': {
    width: "296px",
    display: "flex !important",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  '& .highcharts-pie-series .legend-name': {
    minWidth: "50%",
    marginRight: "10px",
  },
}